import { IApplicationState } from '../../types/redux';

export const selectUserEmail = (state: IApplicationState) => state.user.email;
export const selectUserPhone = (state: IApplicationState) => state.user.phone;
export const selectUserId = (state: IApplicationState) => state.user.userId;
export const selectAnonymousUserId = (state: IApplicationState) => state.user.anonymousUserId;
export const selectIsAuthenticated = (state: IApplicationState) => state.user.isAuthenticated;
export const selectIsAgent = (state: IApplicationState) => Boolean(state.user.isAgent);
